import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import BudgetLibraryItem from './BudgetLibraryItem';
import { Box } from '@mui/system';

type Props = {
    budgetProposal: BudgetProposalT;
};

export default function SortableBudgetProposalItem({
    budgetProposal,
}: Props): React.ReactElement {
    const [delayedDragging, setDelayedDragging] = useState(false);
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: budgetProposal.id });

    // Introduce a slight delay before setting isDragging to true to avoid simple click/drag confusion
    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (isDragging) {
            timeout = setTimeout(() => setDelayedDragging(true), 200);
        } else {
            setDelayedDragging(false);
        }
        return () => clearTimeout(timeout);
    }, [isDragging]);

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Box ref={setNodeRef} sx={style} {...attributes} {...listeners}>
            <BudgetLibraryItem
                budgetProposal={budgetProposal}
                isDragging={delayedDragging}
            />
        </Box>
    );
}
